import { render, staticRenderFns } from "./CreateRoomResultDialog.vue?vue&type=template&id=04c54516"
import script from "./CreateRoomResultDialog.vue?vue&type=script&lang=js"
export * from "./CreateRoomResultDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports